import React from "react";
import { Col, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const ContactDetails = ({ data, refetch }) => {
  const { t } = useTranslation();

  return (
    <div className="add-inner-form">
      <h6 className="text-danger bold">
        {t("personalDetailsWarning")}
      </h6>

      <Form.Group as={Row} className="mb-3" controlId="formHorizontalEmail">
        <Form.Label column sm={2}>
          {t("form.email")}
        </Form.Label>
        <Col sm={10}>
          <Form.Text className="form-control form-control-sm m-0">
            {data?.user?.email}
          </Form.Text>
        </Col>
      </Form.Group>
      <Form.Group as={Row} className="mb-3" controlId="formMobileNumber">
        <Form.Label column sm={2}>
          {t("form.mobileNumber")}
        </Form.Label>
        <Col sm={10}>
          <Form.Text className="form-control form-control-sm m-0">
            {data?.user?.phone}
          </Form.Text>
        </Col>
      </Form.Group>
      <Form.Group as={Row} className="mb-3" controlId="formTelephone">
        <Form.Label column sm={2}>
          {t("form.telephone")}
        </Form.Label>
        <Col sm={10}>
          <Form.Text className="form-control form-control-sm m-0">
            {data?.orgUser?.telephone}
          </Form.Text>
        </Col>
      </Form.Group>
    </div>
  );
};

export default ContactDetails;
